angular.module('sysfeedBackServiceModule', [
	'openEnclosureModule',
])
    .factory('sysfeedBackService', ['$q', '$modal', function($q, $modal) {
        return {
            /**
             * [submitFeedBack description] 提交意见反馈表单
             * @return {[type]} [description]
             */
            openEnclosure:function(item) {
                let deffer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "manageConfig/sysManageMent/feedBack/service/enclosure/enclosure_tpl.html",
                    windowClass: "openEnclosure",
                    backdrop: false,
                    controller: "openEnclosureCtrl",
                    resolve: {
                        item: function() {
                            return item;
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    deffer.resolve();
                }, function() {
                    deffer.reject();
                });
                return deffer.promise;
            },
        };
    }]);